import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { NewsArticle } from './news-article.model';
import { NewsArticleService } from './news-article.service';
import { CRUD_ACTIONS } from '../../shared';

@Component({
    selector: 'jhi-news-article-detail',
    templateUrl: './news-article-detail.component.html'
})
export class NewsArticleDetailComponent implements OnInit, OnDestroy {

    newsArticle: NewsArticle;
    private subscription: any;
    private newsArticleSubscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private newsArticleService: NewsArticleService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['newsArticle']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.newsArticleSubscription = this.eventManager
        .subscribe('newsArticleListModification',
        (response) => {
            this.newsArticle = response['content']['content'];
        });
    }

    load (id) {
        this.newsArticleService.find(id).subscribe(newsArticle => {
            this.newsArticle = newsArticle;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article-detail.component.ts